module.exports = __webpack_public_path__ + "static/media/expert.85497480.png";